<template>
  <b-dropdown
    :mobile-modal="false"
    style="cursor:pointer"
    position="is-bottom-left"
    append-to-body
    aria-role="menu"
  >
    <b-icon slot="trigger" icon="ellipsis-h"></b-icon>
    <b-dropdown-item @click="qrcode(meeting.url_participant)">
      <img src="@/assets/img/icons/qrcode.png" class="icon" alt="icon-qrcode" />
      {{ $t("public.qrcode") }}
    </b-dropdown-item>
    <b-dropdown-item @click="popupParameters(meeting.id)">
      <img
        src="@/assets/img/icons/parameters.png"
        class="icon"
        alt="icon-reset"
      />
      {{ $t("meeting.configurer") }}
    </b-dropdown-item>
    <b-dropdown-item
      :disabled="meeting.state ? true : false"
      @click="preview(meeting.url_participant)"
    >
      <img
        src="@/assets/img/icons/preview-icon.png"
        class="icon"
        alt="preview-icon"
      />
      {{ $t("meeting.preview") }}
    </b-dropdown-item>
    <b-dropdown-item v-if="!this.$store.getters.iframeColidee" @click="shares(meeting.id)">
      <img src="@/assets/img/icons/share.png" class="icon" alt="icon-share" />
      {{ $t("meeting.shares") }}
    </b-dropdown-item>
    <b-dropdown-item @click="duplicate(meeting)">
      <img
        src="@/assets/img/icons/duplicate.png"
        class="icon"
        alt="icon-duplicate"
      />
      {{ $t("meeting.duplicate") }}
    </b-dropdown-item>
    <b-dropdown-item
      @click="exportExcelPdf(meeting.url_moderateur, meeting.id, meeting.name)"
    >
      <img
        src="@/assets/img/icons/export-icon.png"
        class="icon"
        alt="icon-export"
      />
      {{ $t("meeting.exporter") }}
    </b-dropdown-item>

    <b-dropdown-item @click="resetMeeting(meeting.id)">
      <img
        src="@/assets/img/icons/reset-icon.png"
        class="icon"
        alt="icon-reset"
      />
      {{ $t("common.reset") }}
    </b-dropdown-item>
    <b-dropdown-item @click="deleteMeeting(meeting.id)">
      <img src="@/assets/img/icons/delete.png" class="icon" alt="icon-delete" />
      {{ $t("common.supprimer") }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "ParametersDropdown",
  props: {
    meeting: Object,
    cardIndex: Number
  },
  methods: {
    preview (meetingUrlClient) {
      this.$store.commit('SET_AUTHORIZED_PREVIEW', true)
      if (window.location !== window.parent.location) {
        window.location =
          process.env.URL_TEXTIT + '/p-' + meetingUrlClient + '/fr'
      } else {
        window.location = process.env.URL_TEXTIT + '/p-' + meetingUrlClient
      }
    },
    popupParameters (idMeeting) {
      this.$store.dispatch("getMeeting", idMeeting);
      this.$store.dispatch("popupToggle");
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: false,
        parameters: true,
        searchBar: !!this.$store.state.meeting.search_query.length
      });
    },

    sendMessageToParent(taskToDo) {
      let message = {
        task: taskToDo
      };
      window.top.postMessage(message, "*");
    },
    qrcode(meetingUrlClient) {
      var url = "";
      if (this.$store.getters.iframeColidee) {
        url =
          process.env.URL_COLIDEE +
          "o" +
          this.$store.state.authentification.idEntreprise +
          "p" +
          this.$store.state.authentification.idPlateforme +
          "/textit/" +
          meetingUrlClient;
      } else {
        url = process.env.URL_TEXTIT + "/p-" + meetingUrlClient;
      }
      this.$store.commit("MODAL_QRCODE", {
        urlQrCode: url,
        activeModalQrCode: true,
        codeParticipant: meetingUrlClient
      });
      this.sendMessageToParent("scrollToTop");
    },
    shares(meetingId) {
      this.$store.commit("MODAL_SHARES", {
        meetingId: meetingId,
        activeModalShares: true
      });
      this.sendMessageToParent("scrollToTop");
    },
    duplicate(meeting) {
      this.$store.commit("MODAL_DUPLICATE", {
        meeting: meeting,
        activeModalDuplicate: true
      });
      this.sendMessageToParent("scrollToTop");
    },
    exportExcelPdf(urlModerateur, meetingId, meetingName) {
      this.$store.commit("MODAL_EXPORTEXCELPDF", {
        meetingId: meetingId,
        meetingName: meetingName,
        urlModerateur: urlModerateur,
        activeModalExportExcelPdf: true
      });
      this.sendMessageToParent("scrollToTop");
    },
    resetMeeting(meetingId) {
      this.sendMessageToParent("scrollToTop");
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t("button.annuler"),
        confirmText: this.$i18n.t("button.raz"),
        message: this.$i18n.t("meeting.reset"),
        onConfirm: () => this.$store.dispatch("raz_meeting", meetingId)
      });
    },
    deleteMeeting(idMeeting) {
      this.sendMessageToParent("scrollToTop");
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t("meeting.non"),
        confirmText: this.$i18n.t("meeting.oui"),
        message: this.$i18n.t("meeting.confirmer"),
        onConfirm: () => this.$store.dispatch("delete_meeting", idMeeting)
      });
    }
  }
};
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/adminPage/components/ParametersDropdown.vue